var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBudgetEditIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27781_8603)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.5129 2.7312L0.954566 7.2887C0.90856 7.3356 0.874295 7.39271 0.854566 7.45537L0.0212331 9.95537C0.00102859 10.0178 -0.0041553 10.0841 0.00610329 10.1489C0.0163619 10.2137 0.0417731 10.2751 0.0802688 10.3282C0.118765 10.3813 0.169257 10.4246 0.227637 10.4545C0.286018 10.4844 0.350636 10.5001 0.416233 10.5004C0.461026 10.5006 0.505534 10.4932 0.5479 10.4787L3.0479 9.64537C3.11056 9.62564 3.16767 9.59137 3.21457 9.54537L7.77207 4.98703L5.5129 2.7312Z",
    fill: "#056EE6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.87829 2.28871L8.21163 0.622045C8.17292 0.583243 8.12694 0.552457 8.07632 0.531452C8.0257 0.510446 7.97143 0.499634 7.91663 0.499634C7.86182 0.499634 7.80755 0.510446 7.75693 0.531452C7.70631 0.552457 7.66033 0.583243 7.62163 0.622045L6.39746 1.84705L8.65329 4.10288L9.87829 2.87871C9.9171 2.84001 9.94788 2.79403 9.96889 2.74341C9.98989 2.69279 10.0007 2.63852 10.0007 2.58371C10.0007 2.52891 9.98989 2.47464 9.96889 2.42402C9.94788 2.3734 9.9171 2.32742 9.87829 2.28871Z",
    fill: "#056EE6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27781_8603"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "translate(0 0.500366)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBudgetEditIcon);
export default __webpack_public_path__ + "static/media/budgetEditIcon.b62c1d98e9fe17599ab26762f248d1d1.svg";
export { ForwardRef as ReactComponent };